import { Column } from 'components/DataGrid';
import type { GridSummaryRow, RowOrGroup } from '../../types';
import { eachMonthOfInterval, format, formatISO, startOfMonth } from 'date-fns';
import { byKind } from '../columns/createPlanColumn';
import { View } from './View';
import { Edit } from './Edit';
import { Box } from '@ff-it/ui';
import { fmt } from 'utilities';
import { expenseForeground, incomeForeground, monthColumn } from '../columns/style.css';
import { Interval } from '../calendar/types';

export function createMonthColums(interval: Interval): Column<RowOrGroup, GridSummaryRow>[] {
  return eachMonthOfInterval(interval).map((date) => {
    const month = startOfMonth(date);

    const monthString = formatISO(month, { representation: 'date' });
    const key = `month_${monthString}`;

    return byKind({
      key,
      name: format(month, 'MMM. yyyy'),
      className: monthColumn,
      width: 130,
      branches: {
        media: {
          field: 'delivery',
          view: (props) => <View {...props} month={monthString} />,
          edit: (props) => <Edit {...props} month={monthString} />,
          displayCellContent: true,
        },
        service: {
          field: 'delivery',
          view: (props) => <View {...props} month={monthString} />,
          edit: (props) => <Edit {...props} month={monthString} />,
          displayCellContent: true,
        },
        smart: {
          field: 'delivery',
          view: (props) => <View {...props} month={monthString} />,
        },
      },
      renderSummary: ({ row }) => {
        const monthSum = row.summary.months[monthString];
        if (monthSum) {
          return (
            <>
              <Box display="flex" alignItems="center" className={incomeForeground} data-testid="income">
                {fmt(monthSum.income)}
              </Box>
              <Box display="flex" alignItems="center" className={expenseForeground} data-testid="expense">
                {fmt(monthSum.expense)}
              </Box>
            </>
          );
        }
        return null;
      },
    });
  });
}
